export default "__VITE_ASSET__C7JK$dEo__"